/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  // ===== Variant picker fix (added to ensure radio changes update variant id, URL, image, and label) =====
  if (document.body.classList.contains('template-product') && !window.__vpFixOn) {
    window.__vpFixOn = true;
    var __vpForm = document.querySelector('form[action$="/cart/add"]');
    var __vpId = __vpForm && __vpForm.querySelector('input[name="id"]');
    var __vpRadios = __vpForm && __vpForm.querySelectorAll('input[type="radio"][name^="options["]');
    if (__vpForm && __vpId && __vpRadios && __vpRadios.length) {
      var __vpHandle = window.location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
      fetch('/products/' + __vpHandle + '.js').then(function(r){return r.json();}).then(function(p){
        function getOpts(){return p.options.map(function(o){var c=__vpForm.querySelector('input[name="options[' + o.name + ']"]:checked');return c?c.value:null;});}
        function findVar(o){return p.variants.find(function(v){return v.options.every(function(x,i){return x===o[i];});});}
        function update(v){
          if(!v)return;
          __vpId.value=v.id;
          var u=new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
          p.options.forEach(function(o,i){var w=document.querySelector('[data-select-label="' + o.name + '"]');if(w){var t=w.querySelector('[data-swapper-target]');if(t)t.textContent=v.options[i];}});
          if(v.featured_media&&v.featured_media.id){var th=document.querySelector('.media__thumb[data-media-select="' + v.featured_media.id + '"]');if(th)th.click();}
          document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:v}}));
        }
        var ini=new URLSearchParams(window.location.search).get('variant');
        if(ini){var iv=p.variants.find(function(x){return String(x.id)===ini;});if(iv){iv.options.forEach(function(val,i){var rr=__vpForm.querySelector('input[name="options[' + p.options[i].name + ']"][value="' + val + '"]');if(rr)rr.checked=true;});update(iv);}}
        __vpRadios.forEach(function(r){r.addEventListener('change',function(){update(findVar(getOpts()));});});
      })['catch'](function(e){console.warn('[variant-fix] failed', e);});
    }
  }

})();
